import Highcharts from "highcharts/highcharts.js";
window.Highcharts = Highcharts
import Highmaps from "highcharts/highmaps.js";
window.Highmaps = Highmaps
import highchartsMore from "highcharts/highcharts-more.js";
